/*****components***/
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
//import FacebookLogin from 'react-facebook-login';
import { GoogleLogin } from "react-google-login";
/*custom components*/
import PageLoading from "../../components/PageLoading";

import Form from "../../components/Form";
import successIcon from "../../assets/images/ico_success.svg";
import errorIcon from "../../assets/images/ico_error.svg";

import { MDBAlert } from "mdbreact";
import decode from "jwt-decode";
import { toast } from "mdbreact";
import LoginG from "./loginG";
import {
  login,
  getLoginInfo,
  changeHandler,
  getRenderObj,
  getDefValues,
  callApiV2
} from "../../common/functions";
import {
  getS3PublicFile
} from "../../common/functionsV2";
/*functions*/

const foldername = process.env.REACT_APP_FOLDER_LAYOUT;
class page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginFormData: {},
      loginFormConfig: {},
      preRegisterFormData: {},
      preRegisterFormConfig: {},
      emialR: "",
      goHome: false,
      rememberme: true,
      showRecoveryMessage: false,
      showRecoveryErrorMessage: false,
      MetaTags: {
        title: getDefValues().loginLabel,
        names: [
          { name: "description", content: getDefValues().loginLabel },
          { name: "keywords", content: process.env.REACT_APP_ORG_NAME },
          { name: "robots", content: "INDEX,FOLLOW" },
        ],
      },
    };
  }
  /*loading data*/
  componentDidMount = async () => {
    try {
      this.setState({ isLoading: true });
      var token = this.props.match.params.token;
      if (token) {
        if (token === "successful") {
          this.setState({ showSuccessMessage: true });
        } else {
          const { exp } = decode(token);
          if (exp > (new Date().getTime() + 1) / 1000) {
            this.setState({ emialR: decode(token).email });
            var formData = { email: decode(token).email };
            var resp = await callApiV2("frontend", "recoveryPass", formData);
            if (resp.success) {
              this.setState({ showRecoveryMessage: true });
            } else {
              this.setState({ showRecoveryErrorMessage: true });
            }
          }
        }
      }

      var login = getLoginInfo();
      if (login.userId != null) {
        this.setState({ isLoading: false, goHome: true });
      } else {
        this.props.hideCart();
        /*
        let loginForm = await callApi(
          "layaoutManager",
          "getLayoutTemplateByName",
          {
            layoutFile: "loginForm_" + getLanguage(),
            foldername: foldername + "private/",
          }
        );
        let preregisterForm = await callApi(
          "layaoutManager",
          "getLayoutTemplateByName",
          {
            layoutFile: "preregisterForm_" + getLanguage(),
            foldername: foldername + "private/",
          }
        );
        */

        const form1 = await getS3PublicFile(
          process.env.REACT_APP_S3FILES +
          `/public/files/loginForm.json`
        );

        const form2 = await getS3PublicFile(
          process.env.REACT_APP_S3FILES +
          `/public/files/preregisterForm.json`
        );

        let rendegObj = await getRenderObj(
          form1[0],
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
        let rendegObj2 = await getRenderObj(
          form2[0],
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );

        this.setState({
          loginFormData: rendegObj.curdata.data,
          loginFormConfig: rendegObj.curdata.config,
          preRegisterFormData: rendegObj2.curdata.data,
          preRegisterFormConfig: rendegObj2.curdata.config,
          isLoading: false,
        });
      }
    } catch (Excep) {
      console.log(">>>>>>>", Excep);
      this.setState({ isLoading: false });
    }
  };

  changeHandler = async (event) => {
    if (event.target.name === "rememberme") {
      this.setState({
        rememberme: !this.state.rememberme,
      });
    } else {
      //let resp = await validateForm(this.state.loginFormData, toast, event);
      //this.setState({ loginFormData: resp.formData });

      var formData = changeHandler(event, this.state.loginFormData);
      this.setState({ loginFormData: formData });
    }

    if (event.key === "Enter") {
      this.login(event);
    }
  };

  login = async (event) => {
    try {
      this.setState({ isLoading: true });
      console.log("login with credentials")
      var resp = await login(
        this.state.loginFormData,
        this.state.rememberme,
        toast
      );
      if (resp.status) {
        this.setState({ goHome: true });

        if (resp.email && resp.email !== "") {
          var objBloomreach_login = {
            email: resp.email,
            firstname: resp.cliente.firstname || "",
            lastname: resp.cliente.lastname || "",
            lastname2: resp.cliente.lastname2 || "",
            opt_in_ofertas: false,
            opt_in_tyc: true,
            origen: "web",
            phone: resp.cliente.phone || "",
            DNI: resp.cliente.code || "",
            birthday: resp.cliente.fecha_nacimiento
            //aqui pueden añadir los otros atributos que puedan obtener al login
          };
          var objBloomreach_setCustomer = {
            registered: resp.code || "", //Este atributo es OBLIGATORIO, Aqui va la identificacion si se tiene si no va vacia NO ES NULL DEBE IR VACIA si va vacio se debe incluir obligatorio el de email_id que es el soft_id
            email_id: resp.email, //Si se tiene el valor se debe añadir
          };
          console.log("Login BR old");
          window.exponea.track("login", objBloomreach_login);
          window.exponea.update(objBloomreach_login);
          window.exponea.identify(objBloomreach_setCustomer);


          setTimeout(async function () {
            window.location.href = "/";
            window.location.reload();
            //console.log("rel1")
          }, 200);

          localStorage.setItem(
            process.env.REACT_APP_ORG_NAME + "exponea_registered",
            "YES"
          );
        } else {
          console.log("ALERT!! no email");
        }
      }


      this.setState({ isLoading: false });
      this.setState({ successForm: resp.success });
    } catch (Excep) {
      this.setState({ isLoading: false });
      console.log(">>>>>>>", Excep);
    }
  };

  responseFacebook = (response) => {
    console.log(response);
  };



  callBackSNError = (res) => {
    console.log("Login failed: res:", res);
  };
  /*
  handleLogin = async googleData => {
    const res = await fetch("http://localhost:8080/api/v1/auth/google", {
      method: "POST",
      body: JSON.stringify({
        token: googleData.tokenId
      }),
      headers: {
        "Content-Type": "application/json"
      }
    });
    const data = await res.json()
    // store returned user somehow
  }*/
  render() {
    return this.props.showSearcher ? (
      ""
    ) : (
      <>
        {this.state.goHome ? <Redirect to={{ pathname: "/" }} /> : ""}
        <PageLoading
          isLoading={this.state.isLoading}
          MetaTags={this.state.MetaTags}
        />

        <div className="page-wrapper" onClick={this.props.hideCart}>
          <div className="content container-page custom-container container-fluid">
            {this.state.showRecoveryMessage ? (
              <MDBAlert color="success" className="mt-50 mb-30">
                <img
                  className="formIcon"
                  src={successIcon}
                  alt="success-icon"
                />
                <span className="formIcon-span">
                  {" "}
                  {getDefValues().recoveryMessageLabel.replace(
                    "<email>",
                    this.state.emialR
                  )}{" "}
                </span>
              </MDBAlert>
            ) : (
              ""
            )}

            {this.state.showSuccessMessage ? (
              <MDBAlert color="success" className="mt-50 mb-30">
                <img
                  className="formIcon"
                  src={successIcon}
                  alt="success-icon"
                />
                <span className="formIcon-span">
                  {" "}
                  {getDefValues().recoverySuccessMessageLabel}{" "}
                </span>
              </MDBAlert>
            ) : (
              ""
            )}

            {this.state.showRecoveryErrorMessage ? (
              <MDBAlert color="danger" className="mt-50 mb-30">
                <img className="formIcon" src={errorIcon} alt="error-icon" />
                <span className="formIcon-span">
                  {" "}
                  {getDefValues().recoveryErrorMessageLabel.replace(
                    "<email>",
                    this.state.emialR
                  )}{" "}
                </span>
              </MDBAlert>
            ) : (
              ""
            )}

            <div
              className={
                "card  mt-30 " + (!this.state.isLoading ? "card-user-info" : "")
              }
            >
              <div className="row mt-30 mb-30">
                <div
                  className={
                    "mobile-col col-12 col-sm-12 col-md-5 col-lg-5" +
                    (this.props.windowWidth > 992
                      ? " ml-5 border-right"
                      : " ml-1")
                  }
                >
                  <Form
                    customClass={"userForm"}
                    formData={this.state.loginFormData}
                    changeHandler={this.changeHandler}
                    formConfig={this.state.loginFormConfig}
                  />
                  {!this.state.isLoading ? (
                    <div className="col-12 col-lg-9 col-md-9 col-sm-12">
                      <button
                        onClick={this.login}
                        className="accout-btn btn btn-primary text-bold btn-block"
                      >
                        {" "}
                        {getDefValues().loginLabel}{" "}
                      </button>
                      <div className="row" style={{ margin: "10px 0 0 0" }}>
                        <div className="col-6 flex text-left">
                          <label>
                            <input
                              name="rememberme"
                              className="myinput"
                              checked={this.state.rememberme}
                              value="YES"
                              onChange={this.changeHandler}
                              type="checkbox"
                            />{" "}
                            {getDefValues().remembermeLabel}{" "}
                          </label>
                        </div>
                        <div
                          style={{ paddingRight: "0px" }}
                          className="col-6 flex text-right items-right"
                        >
                          <Link to="/customer/account/forgotpassword">
                            {" "}
                            <span className="text-underline">
                              {" "}
                              {getDefValues().forgotPasswordLabel}
                            </span>{" "}
                          </Link>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.props.windowWidth < 992 && !this.state.isLoading ? (
                    <div className="or-line mt-40 mb-2 ml-2 mr-2"></div>
                  ) : (
                    ""
                  )}
                </div>

                <div
                  className={
                    "mobile-col col-12 col-sm-12 col-md-5 col-lg-5" +
                    (this.props.windowWidth < 992 ? " mt-3 " : " ml-3 ")
                  }
                >
                  <Form
                    formData={this.state.preRegisterFormData}
                    changeHandler={this.changeHandler}
                    formConfig={this.state.preRegisterFormConfig}
                  />
                  {!this.state.isLoading ? (
                    <div className="col-12 col-lg-6 col-md-6 col-sm-12 mt-30">
                      <Link to="/customer/account/create">
                        <button className="accout-btn btn btn-outline-primary text-bold btn-block">
                          {" "}
                          {getDefValues().createAccountLabel}{" "}
                        </button>
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="row mb-20">
                {!this.state.isLoading ? (
                  <p className="mobile-col col-12 col-sm-12 col-md-5 col-lg-5 social-login flex items-center">
                    <LoginG
                      setExecuting={() => {
                        this.setState({ isLoading: !this.state.isLoading });
                      }}
                    />

                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default page;